import { defineNuxtPlugin } from '#imports'
import { installAudioUnlock } from '~/utils/audioGain'

// The footer player mounts only after the first play click, too late to catch that gesture.
// Listening from page start lets the very first demo play with loudness normalization.
export default defineNuxtPlugin(() => {
  installAudioUnlock()
})
